import React, {useState} from 'react';
import {useMatch, useNavigate, useParams} from 'react-router-dom';
import useGetMahsuls from './hooks/useGetMahsul';
import SearchInput from 'components/searchInput';
import useDebounce from 'utilities/hooks/debounce/useDebounce';
import DotsLoading from 'components/loadings/dotsLoading';

const PurchaseProducts = () => {
  const navigate = useNavigate();
  const {cateId} = useParams();

  const isFarmRoute = useMatch('/farm/add-ad/purchase/products/:cateId');
  const {products, isLoading} = useGetMahsuls(cateId ? cateId : '');

  const [Search, setSearch] = useState('');
  const searchValue = useDebounce(Search, 500);

  return (
    <>
      <h2 className="w-full flex text-[18px] font-normal">انتخاب نوع محصول</h2>
      <div className="flex flex-col items-center  w-full h-[95%] justify-center gap-4">
        <div className="h-[10%] flex w-full justify-center">
          <SearchInput Search={Search} setSearch={setSearch} />
        </div>
        {isLoading ? (
          <DotsLoading />
        ) : (
          <>
            {products?.results
              ?.filter(item => item.title.includes(searchValue))
              .map((item, index) => (
                <button
                  key={index}
                  className="w-full flex text-gray-6 font-medium text-[15px] leading-[20px]"
                  onClick={() =>
                    navigate(
                      `${
                        isFarmRoute ? '/farm' : '/wholesaler'
                      }/add-ad/purchase/subproducts/${item.guid}`,
                      {
                        state: {
                          title: item.title,
                        },
                      },
                    )
                  }
                >
                  {item.title}
                </button>
              ))}
          </>
        )}
      </div>
    </>
  );
};

export default PurchaseProducts;
